package com.parmartechnologies.core.feature.chat.message.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class Message @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("conversation_id") var ConversationID: String = "",
    @SerialName("message_id") var MessageId: Long = Clock.System.now().epochSeconds,
    @SerialName("content") var Content: String = "",
    @SerialName("content_type") var ContentType: String = "",
    @SerialName("is_uploaded") var IsUploaded: Int = 0,
    @SerialName("is_downloaded") var IsDownloaded: Int = 0,
    @SerialName("is_sent") var IsSent: Int = 0,
    @SerialName("is_received") var IsReceived: Int = 0,
    @SerialName("is_read") var IsRead: Int = 0,
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("sent_time") var SentTime: String = "",
    @SerialName("delivered_time") var DeliveredTime: String = "",
    @SerialName("read_time") var ReadTime: String = "",
): BaseDataClass()
